export default "__VITE_ASSET__Su9LWhH28J3xVc$ztQYMJw__"